export const MessageInputTemplate = `
  <input class="chat__input" placeholder="Write a message..." name="message"/>
  <button class="chat__send-btn" type="submit" aria-label="Send message">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
    </svg>
  </button>
`;
